import styled from "styled-components";
import { mixFont, pageLimit } from "../../makealist/styles/mixins";

const Constants = {
  title: {
    font: {
      size: 24,
      height: 30,
      family: "FuturaPT-Book",
      color: "#000",
    },
    margin: 15,
  },
  subtitle: {
    size: 1100,
  },
  item: {
    margin: {
      desktop: {
        x: 40,
        y: 40,
      },
      mobile: {
        x: 100,
        y: 35,
      },
    },
  },
};

export const Title = styled.div`
  ${mixFont(Constants.title.font)}
  padding: ${Constants.title.margin}px 0;
  padding-top: 25px;
  text-align: center;
`;

export const SubtitleWrapper = styled.div`
  max-width: ${Constants.subtitle.size}px;
  margin: 0 auto;
`;

export const StyledContainer = styled.div`
  padding: 50px;
`;

export const Grid = styled.div`
  ${pageLimit}
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
`;

export const GridItem = styled.div`
  margin-top: ${({ isMobile }) =>
    Constants.item.margin[isMobile ? "mobile" : "desktop"].y}px;
  margin-bottom: ${({ isMobile }) =>
    Constants.item.margin[isMobile ? "mobile" : "desktop"].y}px;
  margin-left: ${({ isMobile }) =>
    Constants.item.margin[isMobile ? "mobile" : "desktop"].x}px;
  margin-right: ${({ isMobile }) =>
    Constants.item.margin[isMobile ? "mobile" : "desktop"].x}px;
  ${({ onClick }) => (onClick ? "cursor: pointer;" : "")};
`;
